import { useState } from "react";
import { Header } from "@/components/Header";
import { SeminarModal } from "@/components/SeminarModal";
import { Seo } from "@/components/Seo";
import { SeminarHero } from "@/sections/SeminarHero";
import { LearnSection, AttendSection, SpeakersSection, AgendaSection, WhySeminarSection, SeminarTrustSection } from "@/sections/SeminarSections";
import { SeminarFaqSection, SeminarFinalCta, SeminarStickyBar, SEMINAR_FAQS } from "@/sections/SeminarClosing";
import { WhatsAppFloat } from "@/sections/Closing";

export default function SeminarPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <>
      <Seo
        title="Free Live Seminar: AI, Cybersecurity & Data Science Careers, Delhi"
        description="A free live online seminar for 12th pass-outs, college students and graduates — get real clarity on starting a tech career in AI, cybersecurity or data science."
        faq={SEMINAR_FAQS}
      />
      <Header onCta={openModal} />
      <SeminarHero onCta={openModal} />
      <LearnSection />
      <AttendSection />
      <SpeakersSection />
      <AgendaSection />
      <WhySeminarSection />
      <SeminarTrustSection />
      <SeminarFaqSection />
      <SeminarFinalCta onCta={openModal} />
      <footer className="py-10 pb-28 sm:pb-10 text-center" style={{ background: "var(--bg-primary)" }} data-testid="seminar-footer">
        <img src="/images/logo.png" alt="Institute logo" className="mx-auto w-14 h-14 rounded-xl object-cover mb-4" style={{ border: "1px solid var(--input-border)" }} data-testid="footer-logo" />
        <p className="text-xs" style={{ color: "var(--text-muted)" }}>
          Tech Career Institute · Delhi · Your details are 100% confidential
        </p>
      </footer>
      <SeminarModal open={modalOpen} onClose={closeModal} />
      <SeminarStickyBar onCta={openModal} hidden={modalOpen} />
      <WhatsAppFloat hidden={modalOpen} />
    </>
  );
}
